// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-search/inventory-search.less
// module id = 3503
// module chunks = 0